import { CobrandIdentifier } from 'features/cobrand/types';
import { color } from 'themes/color';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    extendedPrimary1: { main: string };
    brandShade1: { main: string };
    brandShade2: { main: string };
    blackWithOpacity40: { main: string };
    brandBackgroundPrimary: { main: string };
    brandBackgroundSecondary: { main: string };
    brandTint: { main: string };
    green: {
      800: string;
    };
    red: {
      800: string;
    };
  }

  interface PaletteOptions {
    extendedPrimary1?: { main: string };
    brandShade1?: { main: string };
    brandShade2?: { main: string };
    blackWithOpacity40?: { main: string };
    brandBackgroundPrimary?: { main: string };
    brandBackgroundSecondary?: { main: string };
    brandTint?: { main: string };
    green?: {
      800: string;
    };
    red?: {
      800: string;
    };
  }
}

export const generatePallet = (brand: CobrandIdentifier) => {
  const colors = color[brand];
  return {
    primary: {
      main: colors.primaryMain,
    },
    secondary: {
      main: colors.secondaryMain,
    },
    error: {
      main: colors.errorMain,
    },
    grey: {
      300: colors.grey[300], // Gray 1, Brand Primary Background
      400: colors.grey[400], // Gray 3, Brand Secondary Background
      500: colors.grey[500], // Gray 5
      600: colors.grey[600], // Gray 7
      700: colors.grey[700], // Gray 9
      800: colors.grey[800], // Gray 11
      900: colors.grey[900], // Gray 12
    },
    brandShade1: {
      main: colors.brandShade1,
    },
    brandShade2: {
      main: colors.brandShade2,
    },
    extendedPrimary1: {
      main: colors.extendedPrimary1,
    },
    blackWithOpacity40: {
      main: colors.blackWithOpacity40,
    },
    brandBackgroundPrimary: {
      main: colors.brandBackgroundPrimary,
    },
    brandBackgroundSecondary: {
      main: colors.brandBackgroundSecondary,
    },
    brandTint: {
      main: colors.brandTint,
    },
    green: {
      800: colors.green[800],
    },
    red: {
      800: colors.red[800],
    },
  };
};
